import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { ProductContext } from '@root/modules/Sellers/provider/ProductProvider';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import inventoryService from '@root/modules/Warehouse/Inventory/service/inventory';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Form, Input, message, Modal, Spin } from 'antd';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TableDetailInven from './TableDetailInven';

const DetailProduct = () => {
  const { inventoryId, productId }: any = useParams();
  const { idSellName }: any = useParams();

  const idSell: any = localStorage.getItem('idSeller');

  const [
    idInventory,
    setIdInventory,
    listDetailInventory,
    setListDetailInventory
  ] = useContext<any>(ProductContext);

  const { IdSeller } = useTypedSelector<number | any>(
    (state) => state.getIdSellerReducer
  );

  const [listIn, setListIn] = useState([] as any);
  const [listLocation, setListLocation] = useState([] as any);
  const [listAll, setListAll] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [form] = Form.useForm();

  /*---------------------get getdetail product-----------------*/
  const getDetailInven = async () => {
    setLoading(true);

    const detailList = await inventoryService.getInventoryDetail(
      idSell,
      inventoryId
    );
    setListLocation(detailList.data.location);
    setListAll(detailList.data);
    const listDe: any[] = [];
    const arr: any[] = [detailList.data.product];
    arr.forEach((item: any) => {
      listDe.push({
        productName: item.productName,
        width: item.width,
        length: item.length,
        height: item.height,
        demensionUnit: item.demensionUnit,
        weight: item.weight,
        weightUnit: item.weightUnit,
        estimateQuantity: item.estimateQuantity,
        averageMonthSale: item.averageMonthSale,
        sku: item.sku,
        eanUpc: item.eanUpc,
        asin: item.asin,
        packedMethod: item.packedMethod,
        storageMethod: item.storageMethod,
        dangerousGoods: item.dangerousGoods,
        lotProduct: item.lotProduct,
        image: item?.image?.url
      });
    });
    setListIn(listDe);
    setLoading(false);
  };

  /*--------------*/
  useEffect(() => {
    getDetailInven();
  }, [inventoryId]);

  /*----------set data----------------*/

  useEffect(() => {
    form.setFieldsValue({
      location1: listLocation[0]
    });
  }, [listLocation]);

  /*-------add location----*/

  const [inputList, setInputList] = useState([] as any);

  useEffect(() => {
    const cloneLocation = listLocation.slice(1);

    let arr: any = [];
    if (cloneLocation.length > 0) {
      cloneLocation?.map((item: any) => {
        arr.push({ location: item });
      });
      setInputList(arr);
    }
  }, [listLocation]);

  const handleInputChange = (e: any, index: number) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleRemoveClick = (index: number) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { location: '' }]);
  };

  /*--------handle submit------*/
  const handleSubmit = async (value: any) => {
    const mapInput: any[] = [];
    inputList.forEach((item: any) => {
      mapInput.push(item.location);
    });

    const arrId = {
      locations: [value.location1, ...mapInput]
    };
    setLoading(true);

    const res = await inventoryService.upDateLocation(
      idSell,
      inventoryId,
      arrId
    );
    if (res.message === 'success') {
      setLoading(false);
      // const detailList = await inventoryService.getInventoryDetail(
      //   idSell,
      //   inventoryId
      // );
      getDetailInven();

      // setListLocation(detailList.data.location);
      setShow(true);
    }
    if (res.message === 'Internal server error') {
      setLoading(false);
      message.error('Error');
    }
  };

  return (
    <>
      <Spin spinning={loading} className="loading-forgot">
        <div className="wrapLocation">
          <Form
            form={form}
            onFinish={handleSubmit}
            className="form-location"
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between'
            }}
            initialValues={{
              location1: ''
            }}
          >
            <div className="form-row invenDetail" style={{ width: '85%' }}>
              <label htmlFor="firstName">Location</label>{' '}
              <div className="wrapper">
                <Form.Item name="location1">
                  <Input
                    required
                    type="text"
                    className="form-control"
                    id="location"
                  />
                </Form.Item>
                <div className="form-group col-sm-2">
                  <button
                    className="btn btn-link"
                    type="button"
                    onClick={handleAddClick}
                  >
                    +
                  </button>
                </div>
                {inputList?.map((x: any, i: number) => (
                  <>
                    <div className="wrapInput">
                      <div className="form-group col-sm-6">
                        <input
                          required
                          name="location"
                          value={x.location}
                          onChange={(e) => handleInputChange(e, i)}
                        />
                      </div>
                      <div className="form-group col-sm-2">
                        <button
                          className="btn btn-link"
                          type="button"
                          onClick={() => handleRemoveClick(i)}
                        >
                          -
                        </button>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div
              className="submit-button"
              style={{
                width: '15%',
                position: 'relative'
              }}
            >
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  border: 'none',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-40%, -50%)'
                }}
              >
                Save
              </Button>
            </div>
          </Form>
        </div>

        <div className="detailInventory">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: 'white',
              padding: '12px 19px',
              borderBottom: '0.5px solid #EBECEF'
            }}
          >
            <span>
              Initial Inbound Date:
              {formatDateTime(listAll?.updatedAt)}
            </span>
            <div
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              className="btnNowlocation"
            >
              {' '}
              <Button style={{ width: '350px' }}>
                Now Location :
                {listLocation.map((item: any, index: any) => (
                  <p style={{ display: 'inline' }}>
                    {item}
                    {index === listLocation.length - 1 ? '' : ','}
                  </p>
                ))}
              </Button>
              <Button style={{ width: '350px' }}>
                Remaining Quantity : {listAll.remainQuantity}{' '}
              </Button>
            </div>
          </div>
          <div style={{ backgroundColor: 'white', padding: '19px' }}>
            {listIn.map((item: any) => {
              return (
                <DetailsPro
                  productName={item.productName}
                  width={item.width}
                  height={item.height}
                  length={item.length}
                  demensionUnit={item.demensionUnit}
                  weight={item.weight}
                  weightUnit={item.weightUnit}
                  estimateQuantity={item.estimateQuantity}
                  averageMonthSale={item.averageMonthSale}
                  sku={item.sku}
                  eanUpc={item.eanUpc}
                  asin={item.asin}
                  packedMethod={item.packedMethod}
                  storageMethod={item.storageMethod}
                  dangerousGoods={item.dangerousGoods}
                  lotProduct={item.lotProduct}
                  img={item.image}
                />
              );
            })}
            <TableDetailInven />
          </div>
        </div>
        <Modal
          width={400}
          visible={show}
          onOk={() => {
            setShow(false);
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
          onCancel={() => {
            setShow(false);
          }}
          okButtonProps={{
            style: {
              padding: '.5rem 2.5rem',
              height: 'auto',
              border: 'none',
              borderRadius: '7.25px',
              backgroundColor: '#2B2C51',
              display: 'inline-block'
            }
          }}
          okText="OK"
          maskClosable={true}
        >
          <div>
            <strong>Successful</strong>
          </div>
          <div>Add location success!</div>
        </Modal>
      </Spin>
    </>
  );
};

export default DetailProduct;
